import React from "react";
import DeviceList from "../components/DeviceList";

const Devices = () => {
  return (
    <div>
      <DeviceList />
    </div>
  );
};

export default Devices;